import { useState, useEffect, useRef } from 'react';
import { getSupabase } from '../lib/supabase';

const POLL_INTERVAL_MS = 60_000; // refresh every 60 seconds

export function useFinancingBadge() {
  const [count, setCount] = useState<number>(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetchCount = async () => {
    try {
      const supabase = await getSupabase();
      const { count: total, error } = await supabase
        .from('leads')
        .select('id', { count: 'exact', head: true })
        .eq('lead_type', 'financing')
        .or('status.eq.new,status.is.null');

      if (!error && total !== null) {
        setCount(total);
      }
    } catch {
      // silently fail — badge is non-critical
    }
  };

  useEffect(() => {
    fetchCount();
    timerRef.current = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return count;
}
